
<div class="flex justify-between !px-[15px] !py-0 items-center  !bg-[#F5F5F5] !m-0 sticky top-0 z-10 ">
  <h1 class="!text-[20px] !font-bold  !m-0 Roboto text-[#21252A]">Help BuildXY Auto-Label Uploads</h1>
  <button (click)="closeModal()" class="text-[#000000] ">
      <mat-icon class="!font-black" style="font-size: 25px !important;">close</mat-icon>
  </button>
</div>
<div class=" mx-auto p-4">
    <div class=" ">
    
      <div class="bg-blue-50 px-4 py-2 rounded-md mb-4 flex">
        <mat-icon class="mr-[10px] !w-[26px]">info</mat-icon>
        <p class="text-[#868E96] text-[1rem]">
          When auto labeling the drawing in your upload, IT helps us to know how they are laid out. Here's our best guess at the Number and Title for this drawing: Please make sure we are looking in the right place
        </p>
      </div>
      <form [formGroup]="form">
        <div class="flex flex-col md:flex-row">
          <div class="flex-1 border border-[#A9A9A9] p-4 mb-4 md:mb-0 md:mr-4">
            <div class="border border-[#000000] h-48 mb-4"></div>
            <p class="text-center text-[#343A40] font-semibold">{{ form.get('drawingTitle')?.value }}</p>
            <p class="text-end text-2xl !text-[#343A40] font-bold mt-2">{{ form.get('drawingNumber')?.value }}</p>
          </div>
          <div class="flex-1">
            <div class="mb-4">
                <label class="block text-gray-700 font-semibold mb-2">Drawing Number</label>
                <mat-form-field appearance="outline" class="">
                  <mat-label>Drawing Number</mat-label>
                  <mat-select formControlName="drawingNumber">
                    <mat-option *ngFor="let option of drawingNumbers" [value]="option">
                      {{ option }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              
              <div class="mb-4">
                <label class="block text-gray-700 font-semibold mb-2">Drawing Title</label>
                <mat-form-field appearance="outline" class="w-[25.729vw]">
                  <mat-label>Drawing Title</mat-label>
                  <mat-select formControlName="drawingTitle">
                    <mat-option *ngFor="let title of drawingTitles" [value]="title">
                      {{ title }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              
          </div>
        </div>
        <p class="text-[#1A4971] !text-[14px] mt-4">
          Is the format of this drawing not typical for the set? <a href="#" class="underline">Click here to try a different one</a>
        </p>
        <div class="flex justify-end mt-6">
          <button (click)="skipStep()" class="bg-[#F1F3F5] !text-[1rem] !font-medium text-[#E76B3F] border border-[#E76B3F] px-[20px] py-[10px] rounded-md mr-2">Skip this Step</button>
          <button (click)="confirmAndGoToReview()" class="!bg-[#E76B3F] !text-[1rem] !font-medium !text-[#F1F3F5] px-[20px] py-[10px] rounded-[4px]">Confirm & go to Review</button>
        </div>
      </form>
    </div>
  </div>
  